import React from 'react'

interface Props {
  email: string
  close: () => void
  submit: () => Promise<boolean>
}

const ARFModal = (props: Props) => {
  const handleSubmit = async () => {
    props.close();

    return props.submit();
  }

  return <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h4>You&apos;re about to submit your Appointment Request</h4>
      </div>
      <div className="modal-body">
        <p>A confirmation email will be sent to: <b>{props.email}</b></p>
        <p><b>It is very important that this email address is correct.</b> If the email is incorrect, you will not receive your confirmation or further communication from us.</p>
        <p>Would you like to review your information before submitting?</p>
      </div>
      <div className="modal-footer">
        <button
          onClick={props.close}
          type="button"
          className="btn btn-orange">
          Review Form
        </button>
        <button type="button" className="btn btn-green" onClick={handleSubmit}>Submit ARF</button>
      </div>
    </div>
  </div>;
}

export default ARFModal;
